import React from 'react';
import TopicBubble from '../components/TopicBubble';

const FAQPage = () => {
  const topics = [
    {
      id: 'execution',
      title: 'הוצאה לפועל וחדלות פירעון',
      icon: '⚖️',
      subTopics: [
        { title: 'פתיחת תיק הוצאה לפועל', content: 'תהליך פתיחת תיק הוצאה לפועל...' },
        { title: 'חדלות פירעון', content: 'מהי חדלות פירעון ומתי כדאי להכריז עליה...' },
        { title: 'צווי עיקול', content: 'סוגי צווי עיקול והתמודדות איתם...' }
      ]
    },
    {
      id: 'damages',
      title: 'נזיקין ואזרחי',
      icon: '🏛️',
      subTopics: [
        { title: 'תאונות דרכים', content: 'זכויות נפגעי תאונות דרכים...' },
        { title: 'רשלנות רפואית', content: 'כיצד להתמודד עם מקרי רשלנות רפואית...' },
        { title: 'תביעות ביטוח', content: 'מיצוי זכויות מול חברות ביטוח...' }
      ]
    },
    {
      id: 'realestate',
      title: 'נדל"ן',
      icon: '🏠',
      subTopics: [
        { title: 'עסקאות נדל"ן', content: 'ליווי בעסקאות נדל"ן...' },
        { title: 'תביעות דיירים', content: 'זכויות וחובות בעלי דירות...' },
        { title: 'היתרי בנייה', content: 'הליכי קבלת היתרי בנייה...' }
      ]
    }
  ];

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold text-center mb-12">תחומי התמחות</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {topics.map((topic) => (
          <TopicBubble key={topic.id} {...topic} />
        ))}
      </div>
    </div>
  );
};

export default FAQPage;